<template>
  <el-tabs :ref="'tabs_' + id" :class="{ 'height_auto': autoHeight }" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane v-for="(item, index) in tabList" :label="item.label" :name="item.tabInfo.id + '_' + detailType"
      :key="'tab_' + index">
      <div class="tab_pane_body">
        <InfoTable :ref="item.tabInfo + '_' + detailType" :tableInfo="item.tabInfo" :autoHeight="autoHeight"
          @setParam="setParam">
        </InfoTable>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import InfoTable from './components/infoTable.vue';

import {
  changeNum,
  getChannelVisit,
  getIndustryData,
  getDistributeInfo,
  getDistributeData,
  getProductOrder,
  getProductInfo,
  getProductData,
  getStaffLink,
  getStaffData,
  getTerminalVisit,
  getRelationInfo,
} from '@/api/portrait.js'

export default {
  name: 'detailTables',
  components: {
    InfoTable,
  },
  props: {
    id: '',
    paneType: '',
    autoHeight: true
  },
  data() {
    return {
      idCard: '',
      activeName: '',
      tabList: [],
      detailType: '',
      currTableId: '',
      limit: 50,
    }
  },
  methods: {
    setParam(param, type) {
      this.currTableId = type
      this.getGraphTable(param, false)
    },
    handleClick(tab, event) {
      let index = Number(tab.index)
      if (!this.tabList[index].tabInfo.exist) {
        this.getGraphTable()
      }
    },
    initTable(getData = true) {
      this.detailType = this.paneType || this.$route.query.type
      this.detailData = JSON.parse(this.$route.query.data)
      this.idCard = this.detailData[0].idCard || this.detailData[0].damId
      if (this.detailType == '1') {// 经纪人详情
        this.tabList = [{
          label: '终端资源', tabInfo: {
            id: 'terminal',
            head: [
              { label: '终端名称', field: 'custName', minWidth: '200' },
              { label: '科室', field: 'deptName', width: '100' },
              { label: '医生', field: 'doctorName', width: '100' },
              { label: '最近拜访时间', field: 'newestMaintainTime', width: '120' },
              { label: '最早拜访时间', field: 'earliestMaintainTime', width: '120' },
              { label: '所属省', field: 'provinceName', width: '60' },
              { label: '所属市', field: 'cityName', width: '80' },
              { label: '所属区县', field: 'districtName', width: '80' },
              { label: '拜访次数', field: 'visitNum', minWidth: '100', align: 'right' },
              { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
              { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' }
            ],
            data: null,
            exist: false
          }
        },
        {
          label: '渠道资源', tabInfo: {
            id: 'channel',
            head: [
              { label: '渠道名称', field: 'channelName', minWidth: '200' },
              { label: '部门', field: 'deptName', width: '100' },
              { label: '姓名', field: 'contactName', width: '100' },
              { label: '最近拜访时间', field: 'newestMaintainTime', width: '120' },
              { label: '最早拜访时间', field: 'earliestMaintainTime', width: '120' },
              { label: '所属省', field: 'provinceName', width: '60' },
              { label: '所属市', field: 'cityName', width: '80' },
              { label: '所属区县', field: 'districtName', width: '80' },
              { label: '拜访次数', field: 'visitNum', minWidth: '100', align: 'right' },
              { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
              { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' }
            ],
            data: null,
            exist: false
          }
        },
        {
          label: '产品资源', tabInfo: {
            id: 'product',
            head: [
              { label: '产品名称', field: 'productName', minWidth: '200' },
              { label: '产品规格', field: 'productSpec', minWidth: '160' },
              { label: '生产厂商', field: 'producer', minWidth: '200' },
              { label: '备案药企', field: 'tenantName', minWidth: '200' },
              { label: '价格', field: 'price', align: 'right' },
              { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
              { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' },
            ],
            data: null,
            exist: false
          }
        },
        {
          label: '人员关系', tabInfo: {
            id: 'stuff',
            head: [
              { label: '关系', field: 'link', width: '200' },
              { label: '姓名', field: 'staffName', width: '100' },
              { label: '手机号', field: 'mobile', width: '200' },
              { label: '备案职位', field: 'position' },
              { label: '备案企业', field: 'enterpriseName' }
            ],
            data: null,
            exist: false
          }
        },
        ]
        this.activeName = 'terminal_' + this.detailType
      } else if (this.detailType == '2') {// 终端详情
        this.tabList = [
          {
            label: '产品信息', tabInfo: {
              id: 'product',
              head: [
                { label: '产品名称', field: 'productName', minWidth: '200' },
                { label: '产品规格', field: 'productSpec', minWidth: '160' },
                { label: '生产厂商', field: 'producer', minWidth: '200' },
                { label: '备案药企', field: 'tenantName', minWidth: '200' },
                { label: '价格', field: 'price', align: 'right' },
                { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
                { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' },
              ],
              data: null,
              exist: false
            }
          },
          {
            label: '配送信息', tabInfo: {
              id: 'distribute',
              head: [
                { label: '渠道名称', field: 'channelName', minWidth: '200' },
                { label: '产品名称', field: 'productName', minWidth: '200' },
                { label: '产品规格', field: 'productSpec', minWidth: '160' },
                { label: '生产厂商', field: 'producer', minWidth: '200' },
                { label: '最近配送时间', field: 'newestDeliveryTime', width: '120' },
                { label: '配送数量', field: 'totalNum', minWidth: '100', align: 'right' },
                { label: '配送金额', field: 'amount', minWidth: '160', align: 'right' }
              ],
              data: null,
              exist: false
            }
          },
          {
            label: '终端信息', tabInfo: {
              id: 'terminal',
              head: [
                { label: '终端名称', field: 'custName', minWidth: '200' },
                { label: '科室', field: 'deptName' },
                { label: '医生', field: 'doctorName' },
                { label: '职务', field: 'position' },
                { label: '所属省', field: 'provinceName' },
                { label: '所属市', field: 'cityName' },
                { label: '所属区县', field: 'districtName' },
                // { label: '地址', field: 'visitNum', minWidth: '200' },
              ],
              data: null,
              exist: false
            }
          },
        ]
        this.activeName = 'product_' + this.detailType
      } else if (this.detailType == '3') {// 渠道详情
        this.tabList = [
          {
            label: '产品资料', tabInfo: {
              id: 'product',
              head: [
                { label: '产品名称', field: 'productName', minWidth: '200' },
                { label: '产品规格', field: 'productSpec', minWidth: '160' },
                { label: '生产厂商', field: 'producer', minWidth: '200' },
                { label: '备案药企', field: 'tenantName', minWidth: '200' },
                { label: '价格', field: 'price', minWidth: '100', align: 'right' },
                { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
                { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' },
              ],
              data: null,
              exist: false
            }
          },
          {
            label: '配送资源', tabInfo: {
              id: 'distribute',
              head: [
                { label: '终端名称', field: 'custName', minWidth: '200' },
                { label: '最近配送时间', field: 'newestDeliveryTime', width: '120' },
                { label: '最早配送时间', field: 'earliestDeliveryTime', width: '120' },
                { label: '所属省', field: 'provinceName', width: '60' },
                { label: '所属市', field: 'cityName', width: '80' },
                { label: '所属区县', field: 'districtName', width: '80' },
                { label: '配送次数', field: 'visitNum', minWidth: '100', align: 'right' },
                { label: '配送数量', field: 'totalNum', minWidth: '100', align: 'right' },
                { label: '配送金额', field: 'amount', minWidth: '160', align: 'right' }
              ],
              data: null,
              exist: false
            }
          },
          {
            label: '药企拜访', tabInfo: {
              id: 'industry',
              head: [
                { label: '药企名称', field: 'enterpriseName', minWidth: '200' },
                { label: '备案人员', field: 'name', minWidth: '100' },
                { label: '最近拜访时间', field: 'newestMaintainTime', width: '120' },
                { label: '最早拜访时间', field: 'earliestMaintainTime', width: '120' },
                { label: '所属省', field: 'provinceName', width: '60' },
                { label: '所属市', field: 'cityName', width: '80' },
                { label: '所属区县', field: 'districtName', width: '80' },
                { label: '拜访次数', field: 'visitNum', minWidth: '100', align: 'right' },
                { label: '订单数量', field: 'totalNum', minWidth: '100', align: 'right' },
                { label: '订单金额', field: 'amount', minWidth: '160', align: 'right' }
              ],
              data: null,
              exist: false
            }
          },
          {
            label: '人员资源', tabInfo: {
              id: 'stuff',
              head: [
                { label: '姓名', field: 'name', width: '100' },
                { label: '手机号', field: 'mobile', width: '200' },
                { label: '备案职位/职位', field: 'position' },
                { label: '备案部门/部门', field: 'deptName' }
              ],
              data: null,
              exist: false,
            }
          },
        ]
        this.activeName = 'product_' + this.detailType
      }
      getData && this.getGraphTable();
    },
    // 获取关系网表格
    getGraphTable(param, init) {
      let isInit = init === undefined ? true : init
      let params = param === undefined ? {} : param
      if (this.detailType == '1') {
        params.idCard = this.idCard
      } else {
        params.damId = this.idCard
      }

      if (isInit) {
        params.pageIndex = 1;
        params.pageSize = this.limit
        if (!this.tabList[0].tabInfo.exist) {
          let list = this.tabList.slice(1)
          for (var i = 0; i < list.length; i++) {
            let id = list[i].tabInfo.id
            this.setMethod(id, params, true)
          }
        }
        let id = this.activeName
        this.setMethod(id, params)
      } else {
        let id = this.currTableId
        this.setMethod(id, params)
      }
    },
    // 设置调用接口
    setMethod(id, params, isLoop = false) {
      let method = null
      if (id.indexOf('stuff') > -1) { // 人员
        method = this.detailType == '1' ? getStaffLink : getStaffData
      } else if (id.indexOf('terminal') > -1) { // 终端
        method = this.detailType == '1' ? getTerminalVisit : getRelationInfo
      } else if (id.indexOf('channel') > -1) { // 渠道
        method = getChannelVisit
      } else if (id.indexOf('product') > -1) { // 产品
        method = this.detailType == '1' ? getProductOrder : this.detailType == '2' ? getProductInfo : getProductData
      } else if (id.indexOf('distribute') > -1) { // 配送
        method = this.detailType == '2' ? getDistributeInfo : getDistributeData
      } else if (id.indexOf('industry') > -1) { // 工业
        method = getIndustryData
      }
      if (isLoop) {
        (() => {
          this.setTableData([], id, false)
        })()
      } else {
        method(params).then(res => {
          this.setTableData(res.data, id)
        })
      }
    },
    // 设置表格数据
    setTableData(info, id, isExist = true) {
      let index = 0
      if (id.indexOf('stuff') > -1) { // 人员
        index = 3
      } else if (id.indexOf('terminal') > -1) { // 终端
        index = this.detailType == '1' ? 0 : 2
      } else if (id.indexOf('channel') > -1) { // 渠道
        index = this.detailType == '1' ? 1 : 2
      } else if (id.indexOf('product') > -1) { // 产品
        index = this.detailType == '1' ? 2 : 0
      } else if (id.indexOf('distribute') > -1) { // 配送
        index = 1
      } else if (id.indexOf('industry') > -1) { // 工业
        index = 2
      }
      let tabItem = JSON.parse(JSON.stringify(this.tabList[index]))
      tabItem.tabInfo.curr = info.pageIndex
      tabItem.tabInfo.limit = info.pageSize
      tabItem.tabInfo.count = info.totalRows
      tabItem.tabInfo.page = info.totalPages
      tabItem.tabInfo.exist = isExist
      let data = info.records ? info.records : []
      tabItem.tabInfo.data = data
      if (data.length > 0) {
        tabItem.tabInfo.data = data.map(item => {
          for (var t in item) {
            if (t == 'amt' || t == 'deliveryAmt') {
              item.amount = item[t] ? changeNum(item[t], 2) + '元' : '--'
            } else if (t == 'productPrice') {
              item.price = item[t] ? changeNum(item[t], 2) + '元' : '--'
            } else if (t == 'totalQty' || t == 'deliveryQty') {
              item.totalNum = item[t] ? changeNum(item[t]) : '--'
            } else if (t == 'visitCnt' || t == 'deliveryCnt') {
              item.visitNum = item[t] ? changeNum(item[t]) + '次' : '--'
            } else {
              item[t] = item[t] ? item[t] : '--'
            }
          }
          return item
        })
      }
      // 数组元素改变 更新视图
      this.$set(this.tabList, index, tabItem)
    },
  }
}
</script>

<style lang="less" scoped>
.height_auto {
  /deep/.table_warp {
    height: auto !important;

    >.el-table {
      height: auto !important;

      .el-table__body-wrapper {
        height: auto !important;
      }
    }
  }

}
</style>
